import type { ElementType } from 'react';

type PropositionItemProps = {
  Icon: ElementType;
  title: string;
  className: string;
};

function PropositionItem({ Icon, title, className }: PropositionItemProps) {
  return (
    <div className={`absolute lg:relative overflow-hidden ${className}`}>
      <div className="flex flex-row justify-center items-center text-foreground dark:text-foreground-inverse gap-3 w-76 ">
        <span className="size-5 animate-text-reveal inline-block" style={{ animationDelay: `0.00s` }}>
          <Icon size="small" />
        </span>
        <p className="paragraph-explanatory-strong">
          {title.split(' ').map((word, index) => (
            <span className="animate-text-reveal inline-block" key={`${word}-${index}`} style={{ animationDelay: `${(index + 1) * 0.15}s` }}>
              {`${word}\u00A0`}
            </span>
          ))}
        </p>
      </div>
    </div>
  );
}

type ValuePropositionBarProps = {
  itemOne: ValuePropositionBarItem;
  itemTwo: ValuePropositionBarItem;
  itemThree: ValuePropositionBarItem;
  className?: string;
};

type ValuePropositionBarItem = {
  Icon: ElementType;
  title: string;
};

function ValuePropositionBar({ itemOne, itemTwo, itemThree, className }: ValuePropositionBarProps) {
  return (
    <div
      className={`flex flex-row justify-center items-center gap-1 w-full h-9 bg-accent-green dark:bg-accent-inverse pt-2 pb-2 overflow-hidden ${className}`}
      data-testid="value-proposition-bar"
      data-track-container="Value Proposition"
    >
      <PropositionItem Icon={itemOne.Icon} title={itemOne.title} className="value-proposition-bar-1" />
      <PropositionItem Icon={itemTwo.Icon} title={itemTwo.title} className="value-proposition-bar-2" />
      <PropositionItem Icon={itemThree.Icon} title={itemThree.title} className="value-proposition-bar-3" />
    </div>
  );
}

export { ValuePropositionBar, type ValuePropositionBarProps };
